import { render, staticRenderFns } from "./PromotionLibrary.vue?vue&type=template&id=1ed954a6&"
import script from "./PromotionLibrary.vue?vue&type=script&lang=js&"
export * from "./PromotionLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports